/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { TechSupportItem } from 'ng/modules/items/factories';

export type TTechSupportCollection = typeof TechSupportCollection;

/**
 * @description Tech support collection
 * @author Dhanashree Tilak
 */
export class TechSupportCollection extends Collection {
    public static ngDependencies = [
        TechSupportItem,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'techsupport',
            windowElement: 'lazy-load',
            sortBy: '-_last_modified',
            permissionName: AviPermissionResource.PERMISSION_TECHSUPPORT,
            ...args,
        };

        super(extendedArgs);
        this.itemClass_ = this.getNgDependency(TechSupportItem);
    }
}
